var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useState } from "react";
import styled from "styled-components";
import { uniqBy } from "lodash";
import Select from "@atlaskit/select";
import Form, { Field } from "@atlaskit/form";
import { ExpandablePanel } from "@atlassiansox/microscopekit";
import Button from "@atlaskit/button";
export function Filter(_a) {
    var entities = _a.entities, fields = _a.fields, render = _a.render, _b = _a.includeGap, includeGap = _b === void 0 ? false : _b;
    var _c = __read(useState(true), 2), isCollapsed = _c[0], setIsCollapsed = _c[1];
    var _d = __read(
    // tslint:disable-next-line: no-object-literal-type-assertion
    useState({}), 2), appliedFilter = _d[0], setAppliedFilter = _d[1];
    var filteredEntities = entities.filter(function (entity) {
        return !Object.keys(fields).some(function (field) {
            var _a, _b;
            return ((_a = appliedFilter[field]) === null || _a === void 0 ? void 0 : _a.length) &&
                !((_b = appliedFilter[field]) === null || _b === void 0 ? void 0 : _b.includes(entity[field]));
        });
    });
    return (React.createElement(React.Fragment, null,
        React.createElement(FilterContainer, null,
            React.createElement(ExpandablePanel, { isCollapsed: isCollapsed, title: "Filters", onToggle: function () { return setIsCollapsed(function (prevState) { return !prevState; }); } },
                React.createElement(Form, { onSubmit: setAppliedFilter }, function (_a) {
                    var formProps = _a.formProps;
                    return (React.createElement("form", __assign({}, formProps),
                        Object.entries(fields).map(function (_a) {
                            var _b = __read(_a, 2), field = _b[0], label = _b[1];
                            return (React.createElement(MultiSelect, { key: field, name: field, label: label, placeholder: "Select " + label, options: uniqBy(entities, function (e) { return e[field]; }).map(function (e) { return ({
                                    label: e[field],
                                    value: e[field]
                                }); }) }));
                        }),
                        React.createElement("br", null),
                        React.createElement(Button, { type: "submit", appearance: "primary" }, "Apply")));
                }))),
        includeGap && React.createElement("br", null),
        render(filteredEntities)));
}
var FilterContainer = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  > div {\n    margin-bottom: 0;\n  }\n  .content {\n    overflow: unset;\n    form {\n      padding: 1rem;\n    }\n  }\n"], ["\n  > div {\n    margin-bottom: 0;\n  }\n  .content {\n    overflow: unset;\n    form {\n      padding: 1rem;\n    }\n  }\n"])));
function MultiSelect(_a) {
    var options = _a.options, name = _a.name, label = _a.label, placeholder = _a.placeholder;
    return (React.createElement(Field, { name: name, label: label }, function (_a) {
        var fieldProps = _a.fieldProps;
        return (React.createElement(Select, { className: "multi-select", classNamePrefix: "react-select", options: options, isMulti: true, isSearchable: true, placeholder: placeholder, name: fieldProps.name, onChange: function (selectedOptions) {
                return fieldProps.onChange(selectedOptions === null || selectedOptions === void 0 ? void 0 : selectedOptions.map(function (option) { return option.value; }));
            } }));
    }));
}
var templateObject_1;
